import React from "react"
import "./AboutUs.css"

import david from "./david.jpg"
import davidArmstrong from "./david_armstrong.jpg"
import aleks from "./aleks.jpg"
import mateo from "./mateo.jpg"
import max from "./max.jpg"
import steven from "./steven.jpg"
import edward from "./edward.jpg"
import ted from "./ted.jpg"

const styles = {
  page: {
    fontFamily: "Arial, Helvetica, sans-serif",
    maxWidth: "900px",
    margin: "0 auto",
    padding: "24px 16px",
    lineHeight: 1.6,
    color: "#222",
  },
  sectionTitle: {
    margin: "22px 0 10px 0",
  },
  bio: {
    margin: "14px 0 18px 0",
    padding: "14px 14px",
    border: "1px solid rgba(0,0,0,0.10)",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    overflow: "hidden", // contains the floated image
  },
  bioNoImg: {
    margin: "14px 0 18px 0",
    padding: "14px 14px",
    border: "1px solid rgba(0,0,0,0.10)",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  },
  imgLeft: {
    float: "left",
    width: "160px",
    height: "160px",
    objectFit: "cover",
    borderRadius: "12px",
    margin: "0 14px 10px 0",
    border: "1px solid rgba(0,0,0,0.12)",
  },
  imgRight: {
    float: "right",
    width: "160px",
    height: "160px",
    objectFit: "cover",
    borderRadius: "12px",
    margin: "0 0 10px 14px",
    border: "1px solid rgba(0,0,0,0.12)",
  },
  name: {
    margin: "0 0 8px 0",
    fontSize: "18px",
  },
}

const AboutUs = () => {
  return (
    <div style={styles.page} className="aboutPage">
      <h2 className="aboutTitle" style={{ marginTop: 0 }}>
        The Broadway Maven
      </h2>

      <h3 className="aboutSectionTitle" style={styles.sectionTitle}>
        Faculty
      </h3>

      <section style={styles.bio} className="bioCard">
        <img
          src={david}
          alt="David Benkof"
          style={styles.imgLeft}
          className="bioImgLeft"
        />
        <p style={styles.name} className="bioName">
          <strong>David Benkof</strong>
        </p>
        <p>
          Broadway Maven David Benkof is an educator, essayist, entrepreneur,
          editor, and enthusiast who has made Broadway appreciation his life's
          work. He aims to help his students and readers “think more deeply
          about musical theater,” and the message is spreading: 10,000
          subscribers to his Substacks <em>MARQUEE</em> and StageStreams; more
          than 450 videos at the YouTube channel (including more than 75 on
          Stephen Sondheim alone); and dozens of Broadway Maven classes each
          year with hundreds of students. Among David's more popular offerings
          are his signature “Broadway Blasts,” which take a deep dive into
          beloved musicals, revealing often-surprising insights about lyrics,
          characters, and the creative choices behind them. His favorite musical
          is <em>Into the Woods</em>.
        </p>
      </section>




      <section style={styles.bio} className="bioCard">
        <img
          src={mateo}
          alt="Mateo Chavez Lewis"
          style={styles.imgRight}
          className="bioImgRight"
        />
        <p style={styles.name} className="bioName">
          <strong>Mateo Chavez Lewis</strong>
        </p>
        <p>
          Music educator and frequent Broadway Maven co-host Mateo Chavez Lewis
          is a Toronto and New York-based musical theatre writer/composer whose
          fun but sophisticated “Piano Talks” demonstrating the music theory
          aspects of Broadway shows are a standout feature of Broadway Maven
          classes. An active composer, Mateo wrote the music for{" "}
          <em>Blanchard's Turn</em>, a parody musical about Gypsy Rose Blanchard
          which went viral on TikTok, and <em>Tommy Rhodes</em>, for which a
          studio album was recorded (available on Apple Music &amp; Spotify). He
          will be participating in the prestigious BMI Lehman Engel Musical
          Theatre Workshop starting in the fall of 2025. Mateo also runs the
          Music Theatre Theory YouTube channel. You can hear some of his music
          at{" "}
          <a
            href="https://www.mateochavezlewis.com/"
            target="_blank"
            rel="noreferrer"
          >
            mateochavezlewis.com
          </a>
          . His favorite musical is <em>Company</em>.
        </p>
      </section>



      <section style={styles.bio} className="bioCard">
        <img
          src={edward}
          alt="Edward Barnes"
          style={styles.imgLeft}
          className="bioImgLeft"
        />
        <p style={styles.name} className="bioName">
          <strong>Edward Barnes</strong>
        </p>
        <p>
          Master educator and Juilliard Prof. Edward Barnes has recently joined
          the Broadway Maven team, teaching the music aspects of Broadway about
          once a month. He has composed and/or produced over 50 works for the
          stage, concert hall, radio and recordings. The winner of Guggenheim,
          NEA and NY Foundation for the Arts fellowships, and the Stephen
          Sondheim Award for the “creation of innovative musical theater,” he
          has served as Executive Director of Gotham Chamber Opera, Producing
          Director of MasterVoices, and Managing Director of American Lyric
          Theater. He also teaches his own very popular classes, which you can
          sign up for at{" "}
          <a
            href="https://songbookstation.com/store-1/"
            target="_blank"
            rel="noreferrer"
          >
            songbookstation.com/store-1/
          </a>
          .
        </p>
      </section>


      <section style={styles.bio} className="bioCard">
        <img
          src={davidArmstrong}
          alt="David Armstrong"
          style={styles.imgRight}
          className="bioImgRight"
        />
        <p style={styles.name} className="bioName">
          <strong>David Armstrong</strong>
        </p>
        <p>
          David Armstrong has been a terrific recent addition to the Broadway
          Maven faculty, with his expertise in Broadway history and passion for
          interpreting musicals both famous and less-so. He hosts the popular
          podcast <em>Broadway Nation</em> and teaches about musicals at the
          University of Washington in Seattle, where he has a long career in
          theater. From 2000 to 2018 David served as the Executive Producer and
          Artistic Director of the 5th Avenue Theatre in Seattle. During his
          tenure at The 5th, the company produced 18 new musicals, 9 of which
          went on to have Broadway productions including the Tony-winning
          productions of <em>Hairspray</em> and <em>Memphis</em>. His favorite
          musical is <em>Gypsy</em>.
        </p>
      </section>

      {/* 7) Ted Chapin (newly added) */}
      <section style={styles.bio} className="bioCard">
        <img
          src={ted}
          alt="Ted Chapin"
          style={styles.imgLeft}
          className="bioImgLeft"
        />
        <p style={styles.name} className="bioName">
          <strong>Ted Chapin</strong>
        </p>
        <p>
          Ted Chapin is president of Rodgers &amp; Hammerstein (a division of
          Imagem), a position he has held for 30 years. He has spearheaded many
          a Broadway production during his tenure, the most recent of which is
          Rodgers + Hammerstein’s <em>Cinderella</em>, the first time the 1957
          CBS television-commissioned show has been seen on Broadway, and in a
          newly adapted version. In addition to managing the works of Rodgers
          and/or Hammerstein, the company has taken on the representation of
          other writers, ranging from Irving Berlin to Andrew Lloyd Webber.
        </p>
      </section>


      <section style={styles.bio} className="bioCard">
        <img
          src={steven}
          alt="Steven Bell"
          style={styles.imgRight}
          className="bioImgRight"
        />
        <p style={styles.name} className="bioName">
          <strong>Steven Bell</strong>
        </p>
        <p>
          Steven Bell is a recently retired educator, actor, director, and
          musical director active in New Jersey community theater, with
          literally dozens of productions in each role on his resumé. The year
          2024 was “deep Sondheim” for him, having played Pseudolus in{" "}
          <em>A Funny Thing Happened on the Way to the Forum</em>, musical
          directed <em>Company</em> for the third time, and directed{" "}
          <em>A Little Night Music</em>. He loves talking about and instructing
          about all manner of musicals and is also a commentator on Kyle
          Marshall’s <em>Putting It Together</em> podcast. His favorite musical
          is <em>A Little Night Music</em>.
        </p>
      </section>

      <h3 className="aboutSectionTitle" style={styles.sectionTitle}>
        Co-hosts
      </h3>

      <section style={styles.bio} className="bioCard">
        <img
          src={max}
          alt="Max Clark"
          style={styles.imgRight}
          className="bioImgRight"
        />
        <p style={styles.name} className="bioName">
          <strong>Max Clark</strong>
        </p>
        <p>
          Senior co-host Max Clark has been a Broadway Maven co-host for more than two years,
          mostly handling administrative matters for classes, but has been
          starting to branch out into teaching as well. He is also a third-year
          college student at West Virginia University in the Theatre Department.
          When not working with the Broadway Maven, he's probably outside in the
          forest, rock climbing, or reading a play. His favorite musical is{" "}
          <em>Falsettos</em>.
        </p>
      </section>

      <section style={styles.bioNoImg} className="bioCard">
        <p style={styles.name} className="bioName">
          <strong>Beth Senturia</strong>
        </p>
        <p>
          Beth Senturia moved to New York City in 1985 under the guise of
          attending college, but really to see as much theater as possible. She
          is proud to say that she was at the infamous performance of{" "}
          <em>Gypsy</em> when Patti Lupone stopped the show to throw out a
          photographer. You can find Beth at some type of performance on, or
          off, or off-off Broadway 4-5 times a week. Her “day job” involves the
          financial industry. Her favorite musical is <em>A Chorus Line</em>.
        </p>
      </section>

      <section style={styles.bio} className="bioCard">
        <img
          src={aleks}
          alt="Aleks Salkin"
          style={styles.imgLeft}
          className="bioImgLeft"
        />
        <p style={styles.name} className="bioName">
          <strong>Aleks Salkin</strong>
        </p>
        <p>
          Aleks Salkin is a born and bred Jewish Nebraskan living in Israel.
          When not co-hosting The Broadway Maven, he is a full-time strength and
          fitness coach who also runs an online fitness info publishing business
          and teaches strength training workshops around the world. He is an
          avid language learner, including speaking fluent Hebrew and Italian.
          His favorite musical is <em>The Music Man</em>.
        </p>
      </section>
      <section style={styles.bioNoImg} className="bioCard noImg">
  <p style={styles.name} className="bioName">
    <strong>Tatiana Atehortua</strong>
  </p>
  <p>
    Tatiana Atehortua is a classical percussionist and theater fan living in New
    Jersey. She was a Maven Scholar in 2024.
  </p>
</section>
    </div>
  )
}

export default AboutUs